import * as commonScripts from './common'
import * as componentScripts from './components'

let componentName, componentScript

// append 'is-ie' class for CSS leverage
if (commonScripts.util.detectIE()) {
  document.body.classList.add('is-ie')
}

// wrap tables with responsive container
commonScripts.util.responsiveTables()

// load the canary script
commonScripts.util.loadImgs()

// after document loads loop over all [data-component]s on the page
document.addEventListener('DOMContentLoaded', () => {
  // find all elements with component attribute
  const componentElements = document.querySelectorAll('[data-component]')
  // iterate over all component elements
  for (const el of componentElements) {
    componentName = el.getAttribute('data-component')
    // get the script that matches the component
    componentScript = componentScripts[componentName]
    // if the script exists fire the init
    if (typeof componentScript !== 'undefined') {
      componentScript.init(el)
    }
    // apply component animations if defined
    if (el.getAttribute('data-animate') === 'true') {
      commonScripts.util.componentAnimation(el)
    }
  }
  // Use Intl.DateTimeFormat to get the IANA timezone ID
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const cookieName = "user-timezone";
  const cookieValue = userTimeZone;
  const cookieExists = document.cookie.split(';').some((item) => item.trim().startsWith(cookieName + '='));

  // If the cookie doesn't exist or has a different value, set it and refresh the page.
  // This ensures the server always has the correct timezone for the current session.
  if (!cookieExists || !document.cookie.includes(cookieValue)) {
      document.cookie = `${cookieName}=${cookieValue}; path=/; max-age=${30 * 24 * 60 * 60};`; // Expires in 30 days
      window.location.reload();
  }
})
